import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import useGetFetchConfig, { FetchMethod } from '../useGetFetchConfig';
import { TrackingEvents } from '@/analytics/events';
import { trackCustomEvent } from '@/analytics/Mixpanel';

interface UseBulkDeleteFactsParams {
  factIds: string[];
}

export const useBulkDeleteFacts = (caseId: string) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation(
    async ({ factIds }: UseBulkDeleteFactsParams) => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.DELETE,
        data: { factIds },
      });

      const response = await fetch(`${APIBaseChronos}/api/case/${caseId}/fact/bulk-delete`, fetchConfig);

      if (!response.ok) {
        throw new Error('Failed to archive facts ');
      }

      return response;
    },
    {
      onSuccess: (_) => {
        // Invalidate relevant queries to refresh the data
        queryClient.invalidateQueries({ queryKey: [QueryEntity.CaseFacts] });
        queryClient.invalidateQueries({ queryKey: [QueryEntity.KeyFacts, { caseId }] });
        trackCustomEvent(TrackingEvents.BulkDeleteFacts);

        toast.success('Successfully archived facts');
      },
      onError: (error) => {
        console.error('Bulk delete facts error:', error);
        toast.error('Failed to archive facts');
      },
    },
  );
};
